import {
  AfterContentInit,
  Component,
  ContentChildren, EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  QueryList,
  ViewChild
} from '@angular/core';
import TabComponent from './tab/item';
import {IonSlides} from '@ionic/angular';
import {AbstractSwitchesComponent} from 'app/core/switches.component';
import {BlockElementGroupViewStyleList, BlockElementGroupViewTypeList} from 'app/entities/enums';
import {SwitchRadioCollection} from 'app/entities/switchCollection.entity';

@Component({
  selector: 'app-tabs',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class TabsComponent implements AfterContentInit, OnChanges, OnDestroy {

  @ViewChild('switcherWrapperComponent') switcherWrapperComponent: AbstractSwitchesComponent;

  @Input() paginationType: BlockElementGroupViewTypeList = 'segments';
  @Input() innerScroll = false;
  @Input() renderSegments = true;
  @Input() style?: BlockElementGroupViewStyleList = 'default';
  @Input() containerClass: string = '';
  @Input() hideTabIfSingle = false;

  // Параметр нужен только для того чтобы корректно отобразить sticky у хедеров календаря mbsc-eventcalendar (mobiscroll).
  @Input() overflowVisible = false;

  @Output() changeEvent = new EventEmitter<any>();
  @Output() startChangeEvent = new EventEmitter<any>();
  @Output() readyEvent = new EventEmitter<null>();

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  timer = null;
  ionSlides: IonSlides;

  activeIndex = 0;

  slidesOptions = {
    slidesPerView: 1,
    allowTouchMove: false,
    autoHeight: !this.innerScroll,
  };

  headerSwitch: SwitchRadioCollection = null;

  subs: any = [];

  constructor() {
  }

  @HostBinding('class')
  get classes() {
    return {
      'tabs-inner-scroll': this.innerScroll,
    };
  }

  ngAfterContentInit(): void {
  }

  ngOnChanges(): void {
  }

  ngOnDestroy(): void {
    if (this.subs.length) {
      this.subs.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }

  selectTab(tabId) {
    this.headerSwitch.itemSelect(tabId);
    // this.activeIndex = parseInt(this.headerSwitch.getSelectedId().toString(), 10);
    // this.ionSlides.slideTo(this.activeIndex);
    this.tabSlideChange();
  }

  swiperReady(ionSlides, event) {

    // Проблема: Если один ion-slides вложен в другой ion-slides, это вызывает ошибку - окончание инициализации
    //  у ion-slides-потомка заставляет срабатывать ionSlidesDidLoad и у потомка и у родительского ion-slides.
    //  Решение: сравнивать источник эвента ionSlidesDidLoad и инстанс в котором он срабатывает чтобы исключить ложные срабатывания.
    if (event.target !== ionSlides.el) {
      return;
    }
    // console.log('swiperReady tabs element', ionSlides.el);
    // console.log('swiperReady tabs event target', event.target);
    // console.log('swiperReady tabs event currentTarget', event.currentTarget);

    if (!this.ionSlides) {
      this.ionSlides = ionSlides as IonSlides;

      let selected = null;
      this.headerSwitch = new SwitchRadioCollection(this.tabs.map((item, index) => {

        if (index !== 0 && item.selected) {
          selected = index;
        }

        return {
          id: index,
          title: item.title,
          disabled: item.disabled,
          label: item.label,
          data: {
            enableCounter: item.enableCounter,
            valueCounter: item.valueCounter,
          }
        };
      }));


      if (selected) {
        setTimeout(() => {
          this.headerSwitch.itemSelect(selected);
        }, 100);

      } else {
        this.headerSwitch.selectFirstAvailable();
      }

      this.tabs.forEach((item, index) => {
        this.subs.push(item.changeEvent.subscribe(() => {
          this.headerSwitch.items[index].title = item.title;
          this.headerSwitch.items[index].label = item.label;
          this.headerSwitch.items[index].data = {
            enableCounter: item.enableCounter,
            valueCounter: item.valueCounter,
          };
        }));
      });

      // При инициализации, переключить таб на тот элемент, который item.selected: true
      // Актуально если при инициализации первый элемент по какой-то причине не должен быть выбран (например он disabled).
      this.tabSlideChange();
    }

    this.ionSlides.updateAutoHeight();
    // this.ionSlides.lockSwipes(true);

    this.readyEvent.emit();
  }

  tabSlideChange() {
    const index = parseInt(this.headerSwitch.getSelectedId()?.toString(), 10);
    if (index || index >= 0) {
      this.activeIndex = index;
      this.ionSlides.slideTo(this.activeIndex);
    }
  }

  updateHeight(speed = 500) {
    setTimeout(() => {
      this.ionSlides?.update().then(r => {
        this.ionSlides?.updateAutoHeight(speed);
      });
    }, 1);
  }

  updateHeightContinuously(speed = 500) {
    if (this.timer) {
      clearInterval(this.timer);
    }

    this.timer = setInterval(() => {
      this.updateHeight(speed);
    }, 10);
  }

  updateHeightContinuouslyStop() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  slideChanged() {
    this.ionSlides?.getActiveIndex().then((index) => {
      this.changeEvent.emit(index);
    });
  }

  slideStartChanged() {
    this.ionSlides?.getActiveIndex().then((index) => {
      this.startChangeEvent.emit(index);
    });
  }
}
